const convertDateForHistory = (date: Date): string => {
    return date.toISOString();
}

const formatDateForAnnotation = (date: string | undefined) => {
    if (date === undefined)
        return '';

    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString("en-US", { month: 'short', day: 'numeric' });
    return formattedDate;
};

const formatTimeOfDay = (date: string): string => {
    return new Date(date).toLocaleTimeString("en-US", { hour: 'numeric', minute: '2-digit' });
};

const formatElapsedTime = (fromDate: string, toDate: string): string => {
    const elapsedMs = Math.abs(new Date(toDate).getTime() - new Date(fromDate).getTime());
    const totalHours = Math.floor(elapsedMs / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    if (days > 0)
        return `${days}d ${hours}h`;
    return `${hours}h`;
};

const formatDateForChart = (inputDate: Date): string => {
    const date = new Date(inputDate);
    const offsetMinutes = date.getTimezoneOffset();
    const offsetExtra = offsetMinutes % 60;
    const offsetHours = (offsetMinutes / 60) * 100 + offsetExtra;

    return `${date.toUTCString()} ${offsetHours}`;
    
};

export {
    convertDateForHistory,
    formatDateForAnnotation,
    formatDateForChart,
    formatElapsedTime,
    formatTimeOfDay,
};